import { TableRow } from './TableRow';
import { type FeatureSection } from './types';
interface Props {
  section: FeatureSection;
}
export const TableSection = ({
  section
}: Props) => {
  return <div data-sentry-component="TableSection" data-sentry-source-file="TableSection.tsx">
      <header className="flex items-center gap-xs border-b border-neutral pb-md pt-lg">
        {section.icon}
        <h6 className="text-heading-md-bold">{section.title}</h6>
      </header>
      <div>
        {section.features.map(feature => <TableRow key={feature.id} feature={feature} />)}
      </div>
    </div>;
};